<template>
	<div class="login-container">
		<el-card class="login-card">
			<h1 class="login-title">后台登录</h1>
			<el-form :model="loginForm" :rules="loginRules" ref="loginForm" @submit.native.prevent="handleLogin">
				<!-- 用户名 -->
				<el-form-item prop="username">
					<el-input v-model="loginForm.username" placeholder="请输入用户名或手机号"
						prefix-icon="el-icon-user"></el-input>
				</el-form-item>

				<!-- 密码 -->
				<el-form-item prop="password">
					<el-input v-model="loginForm.password" type="password" placeholder="请输入密码"
						prefix-icon="el-icon-lock"></el-input>
				</el-form-item>

				<!-- 滑块验证 -->
				<el-form-item>
					<drag-verify @pass="isDragVerified = true"></drag-verify>
				</el-form-item>

				<!-- 登录按钮 -->
				<el-form-item>
					<el-button type="primary" native-type="submit" :loading="loading" class="login-button"
						:disabled="!isDragVerified">
						登录
					</el-button>
				</el-form-item>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	import DragVerify from '@/components/DragVerify.vue'; // 引入自定义滑块验证组件
	import {
		apiBaseUrl
	} from '@/config';
	export default {
		name: 'LoginPage',
		components: {
			DragVerify,
		},
		data() {
			return {
				// 登录表单数据
				loginForm: {
					username: '',
					password: '',
					loginType: 2

				},
				// 表单验证规则
				loginRules: {
					username: [{
						required: true,
						message: '请输入用户名',
						trigger: 'blur'
					}, ],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}, ],
				},
				// 登录按钮加载状态
				loading: false,
				// 滑块验证状态
				isDragVerified: false,
			};
		},
		methods: {
			// 处理登录
			async handleLogin() {
				try {
					// 验证表单
					const valid = await this.$refs.loginForm.validate();
					if (!valid) return;

					// 检查滑块验证是否通过
					if (!this.isDragVerified) {
						this.$message.warning('请完成验证');
						return;
					}

					// 设置加载状态
					this.loading = true;

					// 调用登录接口
					const response = await fetch(`${apiBaseUrl}/login.php`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify(this.loginForm),
					});
					const result = await response.json();
					if (result.success) {
						localStorage.setItem('token', JSON.stringify(result.data))
						localStorage.setItem('expires', JSON.stringify(result.expires))
						this.$message.success('登录成功');
						this.$store.commit('setLoggedIn', true);
						let redirect = this.$route.query.redirect || '/';
						this.$router.push(redirect);
					} else {
						// 登录失败，显示错误信息
						this.$message.error(result.message || '登录失败，请重试');
					}
				} catch (error) {
					// 网络错误
					this.$message.error('网络错误，请稍后重试');
					console.error('登录失败:', error);
				} finally {
					// 重置加载状态
					this.loading = false;
				}
			},
		},
	};
</script>

<style scoped>
	.login-container {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100vh;
		background-color: #f8fafc;
	}

	.login-card {
		width: 400px;
		padding: 20px;
		border-radius: 8px;
		box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
	}

	.login-title {
		font-size: 24px;
		font-weight: bold;
		text-align: center;
		margin-bottom: 20px;
		color: #303133;
	}

	.login-button {
		width: 100%;
	}
</style>